import {useIntl} from 'react-intl'
import {KTSVG} from '../../../helpers'
import {FC} from 'react'

type Props = {
  handleClose: () => void | undefined
}

const ClientEditModalHeader: FC<Props> = ({handleClose}) => {
  const intl = useIntl()

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>{intl.formatMessage({id: 'MODAL.TITLE.CLIENT'})}</h2>
      {/* end::Modal title */}
      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-clients-modal-action='close'
        onClick={handleClose}
        style={{cursor: 'pointer'}}
      >
        <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {ClientEditModalHeader}
